<template>
  <div class="home-ask">
    <div class="home-ask__what">
      <!-- inside the booking's own card the booking is already on screen; elsewhere the
           caller says which one this is -->
      <slot><span class="font-weight-semibold">Will you be there?</span></slot>
      <div class="text-muted small">Answer by {{ confirmation.answerBy }}</div>
    </div>

    <div class="home-ask__buttons">
      <b-btn variant="primary btn-sm" :disabled="busy" @click="answer('confirm')">I'll be there</b-btn>
      <b-btn variant="outline-secondary btn-sm" :disabled="busy" @click="answer('cancel')">Cancel</b-btn>
      <!-- one occurrence of a series: turning the whole thing down is a different answer
           from turning down this Tuesday, so it is a button of its own -->
      <b-btn v-if="confirmation.setId" variant="outline-secondary btn-sm" :disabled="busy" @click="answer('cancel-set')">
        Cancel the series
      </b-btn>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

/**
 * The answer to one pending confirmation.
 *
 * It only sends the answer and says how it went; the panel that listed the question is the
 * one that knows what to take off the screen or load again.
 */
export default {
  name: 'HomeAsk',
  props: {
    // a row built by toConfirmationRow()
    confirmation: { type: Object, required: true }
  },
  // set while the answer is on its way, so a second click cannot answer twice
  data: () => ({ busy: false }),
  methods: {
    ...mapActions('desk', ['deskEventConfirmationAct']),
    async answer(action) {
      this.busy = true
      try {
        await this.deskEventConfirmationAct({ id: this.confirmation.id, action })
        this.$emit('answered', action)
      } catch (e) {
        // answered from the email in the meantime, or expired between the load and the
        // click: what is on screen is out of date
        this.$emit('refused')
      } finally {
        this.busy = false
      }
    }
  }
}
</script>

<style scoped lang="scss">
.home-ask {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem 1rem;

  &__what {
    flex: 1 1 200px;
    min-width: 0;
  }

  &__buttons {
    display: flex;
    flex-wrap: wrap;
    gap: 0.5rem;
  }
}
</style>
